var _filter, _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderGreenSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15,
    height: 15,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.501961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(60.784314%,98.823529%,52.156863%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 22.5 19.798177 C 22.5 20.332031 22.291667 20.839844 21.914062 21.210938 C 21.536458 21.588542 21.028646 21.796875 20.501302 21.796875 L 4.498698 21.796875 C 3.971354 21.796875 3.463542 21.588542 3.085938 21.210938 C 2.708333 20.839844 2.5 20.332031 2.5 19.798177 L 2.5 5.800781 C 2.5 5.266927 2.708333 4.759115 3.085938 4.388021 C 3.463542 4.010417 3.971354 3.802083 4.498698 3.802083 L 9.498698 3.802083 L 11.497396 6.796875 L 20.501302 6.796875 C 21.028646 6.796875 21.536458 7.011719 21.914062 7.382812 C 22.291667 7.760417 22.5 8.268229 22.5 8.802083 Z M 22.5 19.798177 ",
    transform: "matrix(0.6,0,0,0.6,0,0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGreenSmall);
export default __webpack_public_path__ + "static/media/folderGreenSmall.f3c5bb6540f58e8cfb8b5fa44147e8db.svg";
export { ForwardRef as ReactComponent };